<script>
    export default {
        name: 'Product Filter',
        props: {
            type: {
                type: String,
                required: false,
                default: 'default'
            },
            name: {
                type: String,
                required: true,
            },
            icon: {
                type: String,
                required: true,
            },
            defaultValue: {
                type: [String, Boolean, Array],
                required: false,
            },
            values: {
                type: [Array, Boolean],
                default: false
            },
            refScroll: {}
        },
        data: () => ({
            minPrice: '',
            maxPrice: '',
            activeOptions: false,
            topFullBlock: 0,
            leftFB: 0,
            paddingFullBlock: 0,
            widthFB: 0,
            value: '',

            teams: [],
            searchText: '',
            isVis: true
        }),
        computed: {
            filteredItems() {
                if (!this.searchText) {
                    return this.values; // Если строка пустая, возвращаем весь массив
                }

                // Фильтруем объекты по всем свойствам
                // Ограничиваем результатом первыми пятью элементами
                return this.values.filter(item => {
                    return Object.entries(item).some(([key, value]) => {
                        return String(value).toLowerCase().includes(this.searchText.toLowerCase());
                    });
                }).slice(0, 5);
            }
        },
        methods: {
            getFullBlockStyles() {
                this.$nextTick(function () {
                    this.topFullBlock = this.$refs.filter?.getBoundingClientRect().bottom * 0.97 + 'px';
                    this.widthFB = this.$refs.filter?.getBoundingClientRect().width + 'px';
                    this.leftFB = this.$refs.filter?.getBoundingClientRect().left + 'px';
                    this.paddingFullBlock = parseInt(getComputedStyle(this.$refs.filter).paddingLeft) - 3 + 'px'
                })

            },
            setNewValue(e) {
                if (e.target.tagName === 'SPAN') {
                    this.value = e.target.textContent;
                } else {
                    try {
                        this.value = e.target.parentNode.querySelector('span').textContent;
                    } catch (e) {
                        return
                    }
                }

                if (this.value === 'Любой' || this.value === 'Любое') {
                    this.$refs.name.textContent = this.name
                } else {
                    this.$refs.name.textContent = this.name + ': ' + this.value
                }
                this.activeOptions = !this.activeOptions

                this.$emit('update:updFilter', this.name, this.value)
            },
            setNewPrice(e) {
                this.$emit('update:updFilter', this.name, [this.minPrice, this.maxPrice])
            },

            onScrollHandler() {
                this.leftFB = this.$refs.filter?.getBoundingClientRect().left + 'px';
                this.setVisible()
            },
            onVerticalScrollHandler(event) {
                this.topFullBlock = (this.$refs.filter?.getBoundingClientRect().bottom + window.scrollY) * 0.97 + 'px';
            },
            resetFilter() {
                this.searchText = ''
                this.value = ''

                this.$refs.name.textContent = this.name
                this.$emit('update:updFilter', this.name, this.value)
            },
            setVisible() {
                const container = this.refScroll;
                const elem = this.$refs.filter?.getBoundingClientRect();

                if (elem && container) {
                    this.isVis = elem.left >= container.getBoundingClientRect().left
                        &&
                        elem.left <= container.getBoundingClientRect().right
                        &&
                        elem.right >= container.getBoundingClientRect().left
                        &&
                        elem.right <= container.getBoundingClientRect().right
                } else {
                    this.isVis = true
                }
            },
        },
        mounted() {
            this.value = this.defaultValue;
            this.getFullBlockStyles()
            this.setVisible()

            this.refScroll.addEventListener('scroll', this.onScrollHandler);
            window.addEventListener('scroll', this.onVerticalScrollHandler);
        },
        unmounted() {
            // Удаление обработчиков событий при выгрузке компонента
            document.removeEventListener('scroll', this.onScrollHandler);
            this.$refs?.refScroll && this.$refs?.refScroll?.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('scroll', this.onVerticalScrollHandler);
        },
        updated() {
            this.getFullBlockStyles()
        }
    }
</script>

<template>
    <div ref="filter" :class="['product-filter', type === 'price' ? 'price-filter' : '', name === 'Состояние' ? 'condition-filter' : '']" @mouseleave="activeOptions = false">
        <div class="filter-header">
            <div class="filter-icon icon" v-html="icon"></div>
            <div class="filter-name">
                <span ref="name">{{ name }}</span>
            </div>
        </div>
        <div v-if="type !== 'price'" style="z-index: 2" :class="['toggle-filter-icon', 'icon', activeOptions ? 'active' : '']" @click="activeOptions = !activeOptions">
            <svg @click.stop.prevent="activeOptions = !activeOptions" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path @click.stop.prevent="activeOptions = !activeOptions" fill-rule="evenodd" clip-rule="evenodd" d="M5.17305 5.66277L0.728516 1.21824L1.83945 0.107299L5.72852 3.99636L9.61758 0.1073L10.7285 1.21824L6.28398 5.66277C6.13665 5.81006 5.93685 5.8928 5.72852 5.8928C5.52018 5.8928 5.32038 5.81006 5.17305 5.66277Z" fill="#1C1C1C"/>
            </svg>
        </div>
        <div v-else class="inputs-filter">
            <input type="number" v-model="minPrice" placeholder="Мин." @change="setNewPrice">
            <span>—</span>
            <input type="number" v-model="maxPrice" placeholder="Макс." @change="setNewPrice">
        </div>


    </div>
    <div :class="['options-outer-block', activeOptions ? 'active' : '', isVis ? 'visible' : 'no-visible']" v-if="filteredItems" ref="optionsBlock" :style="`top: ${topFullBlock}; width: ${widthFB}; left: ${leftFB}`" @mouseover="activeOptions = true" @mouseleave="activeOptions = false">
        <div class="options-inner-block" :style="`padding: ${paddingFullBlock}`">
            <input id="search-input" v-if="type !== 'price' && type !== 'option'" type="text" v-model="searchText" placeholder="Поиск">
            <div v-if="activeOptions && (searchText !== '' || type === 'option')" v-for="v of filteredItems" class="filter-option" @click="setNewValue">
                <svg v-if="v === value || v[name] === value" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="1.42578" width="9" height="9" rx="4.5" stroke="#DC33DF"/>
                    <rect x="2.5" y="3.42578" width="5" height="5" rx="2.5" fill="#DC33DF"/>
                </svg>
                <svg v-else width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="9" height="9" rx="4.5" stroke="#E9E9E9"/>
                </svg>
                <span v-if="typeof v === 'object'">{{ v[name] }}</span>
                <span v-else>{{ v }}</span>
            </div>
            <span id="no-result" v-if="searchText !== '' && filteredItems.length < 1">Варианты не найдены</span>

            <div class="reset" v-if="type !== 'price' && type !== 'option'">
                <div class="hr"></div>
                <span id="reset-filter" @click="resetFilter">Сбросить фильтр</span>
            </div>
        </div>
    </div>
    <div v-if="name === 'Сортировка' || type === 'price'" class="col-hr"></div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
    .product-filter {
        display: inline-flex;
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 1.3%;
        box-sizing: border-box;
        background: $silver;
        border-radius: 10px;

        flex-shrink: 0;

        min-width: 16%;

        height: 36px;
        z-index: 2;

        gap: 10px;

        transition: $transition;
        cursor: pointer;
    }

    .product-filter.condition-filter {
        min-width: 18%;
    }

    .product-filter.price-filter {
        padding-right: 0.7%;
    }

    .filter-header {
        display: flex;
        align-items: center;
        gap: 7px
    }

    .product-filter:hover {
        background: $silver-hover;
    }

    .product-filter span, .options-outer-block span {
        font-size: 12px;
        font-weight: 500;
        color: $black;
        text-transform: uppercase;
        line-height: 150%;
    }

    .product-filter span#no-result {
        color: $hard-gray
    }

    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .col-hr {
        height: 100%;
        border-left: 1px solid $silver;
    }

    .inputs-filter {
        display: flex;
        align-items: center;
        gap: 7px;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .inputs-filter input {
        max-width: 100px;
        height: 100%;
        text-transform: uppercase;
        font-size: 11.5px;
        font-weight: 400;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }

    .options-outer-block {
        position: absolute;
        width: 100%;
        background: $silver;
        border-radius: 0 0 10px 10px;
        transition: $transition;
        box-sizing: border-box;
        padding: 2px;
        top: 0;
        left: 0;
        z-index: 3;

        opacity: 0;
        transform: translateY(-10px); /* Начальное положение: сдвинут вверх на 10px */
    }

    .options-outer-block.no-visible {
        display: none;
    }

    .options-outer-block.visible {
        display: block;
    }

    .options-outer-block #search-input {
        font-size: 11.5px;
        font-weight: 500;
        color: $black;
        text-transform: uppercase;
        margin-bottom: 5px;
        padding-top: 4%;
        padding-bottom: 4%;
    }

    .options-outer-block.active {
        opacity: 1; /* Конечная прозрачность */
        transform: translateY(0); /* Конечное положение: исходное */
    }

    .options-inner-block {
        background: $white;
        border-radius: 10px;
        padding-top: 10px !important;
        padding-bottom: 7px !important;

        display: flex;
        flex-direction: column;
        gap: 5px;
        transition: $transition;
    }

    .filter-option {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 7px;
        word-break: break-all;
        cursor: pointer;
    }

    .filter-option svg {
        flex-shrink: 0;
    }

    .product-filter:hover .options-outer-block {
        background: $silver-hover;
    }

    .toggle-filter-icon {
        height: 100%; padding: 5px; box-sizing: border-box;
        transition: $transition;
    }

    .toggle-filter-icon.active {
        transform: rotate(-180deg);
    }

    #reset-filter {
        text-decoration: underline;
        color: $hard-gray;
        font-size: 11px;
        display: inline-block;
        text-align: center;
        cursor: pointer;
    }

    .reset {
        width: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .hr {
        background: none;
        border-top: 1px dashed $silver !important;
    }

    @media screen and (max-width: 750px) {
        .product-filter {
            padding: 0 12px;
            height: 32px;
            box-sizing: border-box;
        }

        .filter-icon > * {
            width: 15px !important;
            height: auto !important;
        }

        .toggle-filter-icon > * {
            width: auto !important;
            height: 7px !important;
        }

        .options-outer-block #search-input {
            font-size: 10px !important;
        }

        .product-filter span, .options-outer-block span {
            font-size: 10px !important;
        }

        .inputs-filter input {
            font-size: 10px !important;
        }
    }
</style>